import {
  Ban,
  Building2,
  CalendarClock,
  ClipboardCheck,
  Globe,
  MailX,
  PhoneMissed,
  PhoneOff,
  Printer,
  ShieldAlert,
  UserX,
  type LucideIcon,
} from 'lucide-react'

import {
  VoENextActionOwner,
  VoENextActionReason,
} from 'src/graphql/types/verificationOfEmployments'

import type { NextActionText } from './nextActionText'

/** The automation rows: a step on the calendar. */
export const SCHEDULED_ICON: LucideIcon = CalendarClock

/** One icon per reason a person has the next move, so the row reads at a glance. */
export const REASON_ICONS: Record<VoENextActionReason, LucideIcon> = {
  [VoENextActionReason.REVIEW_RESPONSE]: ClipboardCheck,
  [VoENextActionReason.PLATFORM]: Globe,
  [VoENextActionReason.FAX]: Printer,
  [VoENextActionReason.EMAILS_EXHAUSTED]: MailX,
  [VoENextActionReason.CALLS_EXHAUSTED]: PhoneMissed,
  [VoENextActionReason.WRONG_NUMBER]: PhoneOff,
  [VoENextActionReason.NO_CONTACT_INFO]: UserX,
  [VoENextActionReason.DO_NOT_CONTACT]: ShieldAlert,
  [VoENextActionReason.NOT_A_CARRIER]: Ban,
  [VoENextActionReason.CURRENT_EMPLOYER]: Building2,
}

export interface NextActionVisual {
  Icon: LucideIcon
  /** Brand blue for automation, amber for a person's move. */
  iconClass: string
  labelClass: string
  /** The short text beside the icon: "Scheduled" or the reason. */
  label: string
}

/** The one place the tag and the drawer line agree on icon, colour and label. */
export const nextActionVisual = (text: NextActionText): NextActionVisual => {
  const scheduled = text.owner === VoENextActionOwner.AUTOMATED
  return {
    Icon: scheduled
      ? SCHEDULED_ICON
      : REASON_ICONS[text.reason ?? VoENextActionReason.NO_CONTACT_INFO],
    iconClass: scheduled
      ? 'text-doubleNickel-brand-500'
      : 'text-doubleNickel-warning-500',
    labelClass: scheduled
      ? 'text-doubleNickel-brand-700'
      : 'text-doubleNickel-warning-600',
    label: scheduled ? text.label : text.detail ?? text.label,
  }
}
